import { render, staticRenderFns } from "./invoicesStatus.vue?vue&type=template&id=1a19967f&"
import script from "./invoicesStatus.vue?vue&type=script&lang=js&"
export * from "./invoicesStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports